import { LOCAL_CONFIG } from './config.local';
import { buildProdConfig } from './config.production';

/**
 * Explicit env -> config map. Each entry is a thunk so that only the selected
 * environment's config is ever constructed (the production one validates
 * VITE_ULTIVERSE_DOMAIN and throws if it is missing).
 *
 * The previous `=== 'production' ? PROD : LOCAL` check silently fell through to
 * LOCAL_CONFIG for any other value, so `build:test` (VITE_ULTIVERSE_ENV=test)
 * produced a "test" bundle pointing at http://localhost:3030.
 */
const CONFIGS = {
    local: () => LOCAL_CONFIG,
    test: buildProdConfig,
    production: buildProdConfig
};

const env = import.meta.env.VITE_ULTIVERSE_ENV || 'local';

if (!CONFIGS[env]) {
    throw new Error(
        `Unknown VITE_ULTIVERSE_ENV "${env}". Expected one of: ${Object.keys(CONFIGS).join(', ')}`
    );
}

export const ULTIVERSE_ENV = env;
export const APP_CONFIG = CONFIGS[env]();
